import classnames from 'classnames';

import { IconSize } from './constants';
import { styles } from './styles';
import { getSizeStyle } from './utils';

export type IconInterface = {
  source: string;
  size?: IconSize | number;
  isDisabled?: boolean;
  className?: string;
  isSquare?: boolean;
  alt?: string;
};

const Icon = ({
  source,
  size = IconSize.MEDIUM,
  isDisabled = false,
  className,
  isSquare = true,
  alt = 'Icono'
}: IconInterface) => {
  const { classes } = styles();

  return (
    <img src={source} alt={alt} className={classnames({ [classes.disabled]: isDisabled }, className)}  {...getSizeStyle(size, isSquare)} />
  );
};

export default Icon;
